<div class="certificate-hull-cover-provision flex flex-col gap-6"
     [formGroup]="form()"
>
  <div *albertIfCategory="'objectType'; config: visibility">
    <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-object-type"
                          groupName="objectType"
                          tooltipLabel="Object Type"
                          [disabled]="!canEdit()"
    >
      <albert-select controlName="objectType"
                     inputId="objectType"
                     label="Object Type"
                     [attr.data-test]="'certificate-hull-cover-provision-object-type'"
                     [disabled]="!canEdit()"
                     [options]="objectTypeOptions"
                     [required]="true"
      />
    </albert-input-wrapper>
  </div>
  <div *albertIfCategory="'aircraftType'; config: visibility"
       class="comparison-grid expanded-mode"
       data-test="certificate-hull-cover-provision-comparison-grid-0"
  >
    <div class="flex flex-col gap-6">
      @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE &&
      form().controls.objectType.value === objectType.AIRCRAFT) {
        <albert-input controlName="aircraftType"
                      data-test="certificate-hull-cover-provision-aircraft-type"
                      groupName="aircraftType"
                      inputId="aircraftType"
                      label="Aircraft Type"
                      [disabled]="true"
        />
      }
      @if (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES ||
      categoryService.activeCertificateCategory() === CertificateCategory.CONTRACTUAL) {
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-type"
                              groupName="aircraftType"
                              tooltipLabel="Aircraft Type"
                              [disabled]="!canEdit()"
        >
          <albert-multiselect controlName="aircraftType"
                              dataTest="certificate-hull-cover-provision-aircraft-type"
                              inputId="aircraftType"
                              label="Aircraft Type"
                              [disabled]="!canEdit()"
                              [filter]="true"
                              [maxSelectedLabels]="3"
                              [options]="aircraftTypeOptions()"
          />
        </albert-input-wrapper>
      }
    </div>
    @if ((categoryService.activeCertificateCategory() === CertificateCategory.LEASE && form().controls.objectType.value === objectType.AIRCRAFT) ||
    (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES ||
      categoryService.activeCertificateCategory() === CertificateCategory.CONTRACTUAL)) {
      <div *albertIfCategory="'aircraftTypeForCertificates'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-type-for-cert"
                              groupName="aircraftTypeForCertificates"
                              tooltipLabel="Aircraft Type for Certificates"
                              [disabled]="!canEdit()"
        >
          <albert-input controlName="aircraftTypeForCertificates"
                        data-test="certificate-hull-cover-provision-aircraft-type-for-cert"
                        groupName="aircraftTypeForCertificates"
                        inputId="aircraftTypeForCertificates"
                        label="Aircraft Type for Certificates"
                        [disabled]="!canEdit()"

          />
        </albert-input-wrapper>
      </div>

      <div *albertIfCategory="'aircraftSerialNumber'; config: visibility">
        <albert-input-wrapper actionsLayout="row"
                              data-test="wrapper-certificate-hull-cover-provision-aircraft-serial-number"
                              groupName="aircraftSerialNumber"
                              tooltipLabel="Aircraft Serial Number"
                              [disabled]="!canEdit()"
        >
          <albert-select controlName="aircraftSerialNumber"
                         data-test="certificate-hull-cover-provision-aircraft-serial-number"
                         dataKey="uuid"
                         inputId="aircraftSerialNumber"
                         label="Aircraft Serial Number"
                         optionLabel="serialNumber"
                         optionValue="serialNumber"
                         [disabled]="!canEdit()"
                         [editable]="true"
                         [filter]="true"
                         [options]="aircraftSchedules() ?? []"
                         [required]="categoryService.activeCertificateCategory() === CertificateCategory.LEASE"
          />
          @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE) {
            <ng-container actions>
              @let schedule = matchedAircraftSchedule();
              <span class="w-fit"
                    tooltipPosition="left"
                    [pTooltip]="'View Aircraft Schedule in Origami'"
              >
                <button class="link-input-btn"
                        data-test="certificate-hull-cover-provision-aircraft-serial-number-link"
                        iconOnly
                        outlined="true"
                        pButton
                        severity="secondary"
                        type="button"
                        [disabled]="!schedule"
                        (click)="schedule && onOpenAircraftScheduleInOrigami(schedule.externalId)"
                >
                  <i class="pi pi-external-link"></i>
                </button>
              </span>
            </ng-container>
          }
        </albert-input-wrapper>
      </div>

      <div *albertIfCategory="'aircraftRegistration'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-registration"
                              groupName="aircraftRegistration"
                              tooltipLabel="Aircraft Registration"
                              [disabled]="!canEdit()"
        >
          <albert-select controlName="aircraftRegistration"
                         data-test="certificate-hull-cover-provision-aircraft-registration"
                         dataKey="uuid"
                         inputId="aircraftRegistration"
                         label="Aircraft Registration"
                         optionLabel="registration"
                         optionValue="registration"
                         [disabled]="!canEdit()"
                         [editable]="true"
                         [filter]="true"
                         [options]="aircraftSchedules() ?? []"
                         [required]="categoryService.activeCertificateCategory() === CertificateCategory.LEASE"

          />
        </albert-input-wrapper>
      </div>
    }
  </div>
  @if (form().controls.objectType.value === objectType.AIRCRAFT) {
    <div *albertIfCategory="'titledEngines'; config: visibility"
         class="comparison-grid expanded-mode"
         data-test="certificate-hull-cover-provision-comparison-grid-1"
    >
      @for (titledEngineGroup of titledEngines.controls; track titledEngineGroup; let i = $index) {
        <div [formGroup]="titledEngineGroup">
          <albert-input controlName="serialNumber"
                        errorMessage="Only letters and digits with at most one hyphen, 2 to 8 characters in total."
                        groupName="serialNumber"
                        [attr.data-test]="'certificate-hull-cover-provision-titled-engine-serial-number-'+ (i+1)"
                        [disabled]="!canEdit()"
                        [inputId]="'titledEngineSerialNumber' + (i+1)"
                        [label]="'Titled Engine Serial Number #' + (i+1)"
                        [required]="true"
          />
        </div>
        <div class="override-cell flex flex-row gap-4"
             [formGroup]="titledEngineGroup"
        >
          <div class="grow">
            <albert-select controlName="type"
                           dataKey="uuid"
                           optionLabel="description"
                           optionValue="description"
                           [attr.data-test]="'certificate-hull-cover-provision-titled-engine-type-'+ (i+1)"
                           [disabled]="!canEdit()"
                           [filter]="true"
                           [inputId]="'titledEngineType' + (i+1)"
                           [label]="'Titled Engine Type #' + (i+1)"
                           [options]="engineTypeOptions()"
            />
          </div>
          <div>
            <button class="clear-input-btn"
                    iconOnly
                    pButton
                    severity="secondary"
                    type="button"
                    [disabled]="!canEdit()"
                    [outlined]="true"
                    (click)="onRemoveTitledEngines(i)"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>
      }

      <div>
        <div>
          <button pButton
                  severity="secondary"
                  type="button"
                  [disabled]="!canEdit() || titledEngines.length === 4"
                  (click)="onAddTitledEngine()"
          >
            Add Titled Engine
          </button>
        </div>
      </div>
      <div class="override-cell"></div>

    </div>
  }
  @if (form().controls.objectType.value === objectType.AIRCRAFT) {
    <div *albertIfCategory="'engineGrossupClause'; config: visibility"
         class="comparison-grid expanded-mode"
         data-test="certificate-hull-cover-provision-comparison-grid-1"
    >
      <div>
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-engine-grossup-clause"
                              groupName="engineGrossupClause"
                              tooltipLabel="Engine Gross-up Clause"
                              [disabled]="!canEdit() || form().controls.engineGrossUpClauseFreetextCheckbox.value === true"
        >
          <albert-select controlName="engineGrossupClause"
                         data-test="certificate-hull-cover-provision-engine-grossup-clause"
                         inputId="engineGrossupClause"
                         label="Engine Gross-up Clause"
                         [disabled]="!canEdit() || form().controls.engineGrossUpClauseFreetextCheckbox.value === true"
                         [options]="engineGrossupClauseOptions"
          />
        </albert-input-wrapper>
      </div>
      <div *albertIfCategory="'engineGrossUpClauseFreetext'; config: visibility"
           class="override-cell flex flex-col gap-4"
      >
        <albert-checkbox controlName="engineGrossUpClauseFreetextCheckbox"
                         data-test="certificate-hull-cover-provision-engine-grossup-clause-freetext-checkbox"
                         groupName="engineGrossUpClauseFreetextCheckbox"
                         inputId="engineGrossUpClauseFreetextCheckbox"
                         label="Engine Gross-up Clause Freetext"
                         [disabled]="!canEdit()"
        />
        @if (form().controls.engineGrossUpClauseFreetextCheckbox.value) {
          <albert-input-wrapper controlName="engineGrossUpClauseFreetext"
                                data-test="wrapper-certificate-hull-cover-provision-engine-grossup-clause-freetext-text"
                                groupName="engineGrossUpClauseFreetext"
                                tooltipLabel="Engine Gross-up Clause Freetext"
                                [disabled]="!canEdit()"
          >
            <albert-textarea controlName="engineGrossUpClauseFreetext"
                             data-test="certificate-certificate-hull-cover-provision-engine-grossup-clause-freetext-text"
                             groupName="engineGrossUpClauseFreetext"
                             inputId="engineGrossUpClauseFreetext"
                             [disabled]="!canEdit()"
                             [label]="'Engine Gross-up Clause Freetext'"
                             [rows]="6"
            />
          </albert-input-wrapper>
        }
      </div>
    </div>
  }

  <div class="comparison-grid expanded-mode"
       data-test="certificate-hull-cover-provision-comparison-grid-2"
  >
    <div *albertIfCategory="'equipmentType'; config: visibility"
         class="flex flex-col gap-6"
    >
      @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE &&
      (form().controls.objectType.value === objectType.ENGINE || form().controls.objectType.value === objectType.EQUIPMENT)) {
        <albert-input controlName="equipmentType"
                      data-test="certificate-hull-cover-provision-equipment-type"
                      groupName="equipmentType"
                      inputId="equipmentType"
                      label="Equipment Type"
                      [disabled]="true"

        />
      }
      @if (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES ||
      categoryService.activeCertificateCategory() === CertificateCategory.CONTRACTUAL) {
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-equipment-type"
                              groupName="equipmentType"
                              tooltipLabel="Equipment Type"
                              [disabled]="!canEdit()"
        >
          <albert-select controlName="equipmentType"
                         data-test="certificate-hull-cover-provision-equipment-type"
                         dataKey="uuid"
                         inputId="equipmentType"
                         label="Equipment Type"
                         optionLabel="description"
                         optionValue="description"
                         [disabled]="!canEdit()"
                         [options]="equipmentTypeOptions()"
          />
        </albert-input-wrapper>
      }
    </div>
    @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE &&
    (form().controls.objectType.value === objectType.ENGINE || form().controls.objectType.value === objectType.EQUIPMENT) ||
    (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES ||
      categoryService.activeCertificateCategory() === CertificateCategory.CONTRACTUAL)) {
      <div *albertIfCategory="'equipmentTypeForCertificate'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-equipment-type-for-cert"
                              groupName="equipmentTypeForCertificate"
                              tooltipLabel="Equipment Type for Certificates"
                              [disabled]="!canEdit()"
        >
          <albert-input controlName="equipmentTypeForCertificate"
                        data-test="certificate-hull-cover-provision-equipment-type-for-cert"
                        groupName="equipmentTypeForCertificate"
                        inputId="equipmentTypeForCertificate"
                        label="Equipment Type for Certificates"
                        [disabled]="!canEdit()"

          />
        </albert-input-wrapper>
      </div>

      <div>
        <albert-input-wrapper *albertIfCategory="'equipmentSerialNumber'; config: visibility"
                              actionsLayout="row"
                              data-test="wrapper-certificate-hull-cover-provision-equipment-serial-number"
                              groupName="equipmentSerialNumber"
                              tooltipLabel="Equipment Serial Number"
                              [disabled]="!canEdit()"
        >
          <albert-select controlName="equipmentSerialNumber"
                         data-test="certificate-hull-cover-provision-equipment-serial-number"
                         dataKey="uuid"
                         groupName="equipmentSerialNumber"
                         inputId="equipmentSerialNumber"
                         label="Equipment Serial Number"
                         optionLabel="serialNumber"
                         optionValue="serialNumber"
                         [disabled]="!canEdit()"
                         [editable]="true"
                         [filter]="true"
                         [options]="equipmentSchedules() ?? []"
                         [required]="categoryService.activeCertificateCategory() === CertificateCategory.LEASE"

          />
          @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE) {
            <ng-container actions>
              @let schedule = matchedEquipmentSchedule();
              <span class="w-fit"
                    tooltipPosition="left"
                    [pTooltip]="'View Equipment Schedule in Origami'"
              >
                <button class="link-input-btn"
                        data-test="certificate-hull-cover-provision-equipment-serial-number-link"
                        iconOnly
                        outlined="true"
                        pButton
                        severity="secondary"
                        type="button"
                        [disabled]="!schedule"
                        (click)="schedule && onOpenEquipmentScheduleInOrigami(schedule.externalId)"
                >
                  <i class="pi pi-external-link"></i>
                </button>
              </span>
            </ng-container>
          }
        </albert-input-wrapper>
      </div>
      <div *albertIfCategory="'equipmentTypeFreetextCheckbox'; config: visibility"
           class="override-cell flex flex-col gap-4"
      >
        <albert-checkbox controlName="equipmentTypeFreetextCheckbox"
                         data-test="certificate-hull-cover-provision-equipment-freetext-checkbox"
                         groupName="equipmentTypeFreetextCheckbox"
                         inputId="equipmentTypeFreetextCheckbox"
                         label="Equipment Freetext"
                         [disabled]="!canEdit()"
        />
        @if (form().controls.equipmentTypeFreetextCheckbox.value) {
          <albert-input-wrapper controlName="equipmentTypeFreetext"
                                data-test="wrapper-certificate-hull-cover-provision-equipment-freetext-text"
                                groupName="equipmentTypeFreetext"
                                tooltipLabel="Equipment Freetext"
                                [disabled]="!canEdit()"
          >
            <albert-textarea controlName="equipmentTypeFreetext"
                             data-test="certificate-certificate-hull-cover-provision-equipment-freetext-text"
                             groupName="equipmentTypeFreetext"
                             inputId="equipmentTypeFreetext"
                             [disabled]="!canEdit()"
                             [label]="'Equipment Freetext'"
                             [rows]="6"
            />
          </albert-input-wrapper>
        }
      </div>
    }
  </div>

  <div *albertIfCategory="'leaseValues'; config: visibility">
    <div class="flex flex-col gap-4 w-full">
      @for (leaseValueGroup of leaseValues.controls; track leaseValueGroup; let i = $index) {
        <div class="flex flex-row gap-4 items-end"
             [formGroup]="leaseValueGroup"
        >
          <albert-limit class="flex-1"
                        currencyControlName="currency"
                        currencyGroupName="currency"
                        currencyLabel="Currency"
                        limitControlName="amount"
                        limitGroupName="amount"
                        limitLabel="Lease Value Amount"
                        [currencyInputId]="'leaseValuesCurrency' + i"
                        [disabled]="!canEdit()"
                        [limitInputId]="'leaseValues' + i"
          />
          <button class="clear-input-btn"
                  iconOnly
                  pButton
                  severity="secondary"
                  type="button"
                  [disabled]="!canEdit() || leaseValues.length === 1"
                  [outlined]="true"
                  (click)="onRemoveLeaseValue(i)"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
      }
      <div class="flex flex-row justify-between items-center">
        <div *albertIfCategory="'leaseValues'; config: visibility">
          <button pButton
                  severity="secondary"
                  type="button"
                  [disabled]="!canEdit()"
                  (click)="onAddLeaseValue()"
          >
            Add Lease Values
          </button>
        </div>
        <div *albertIfCategory="'leaseValueTba'; config: visibility">
          <albert-checkbox controlName="leaseValueTba"
                           data-test="certificate-hull-cover-provision-lease-value-tba"
                           groupName="leaseValueTba"
                           inputId="leaseValueTba"
                           label="Lease Value TBA"
                           [disabled]="!canEdit()"
          />
        </div>
      </div>
    </div>
  </div>

  <div *albertIfCategory="'leaseValues'; config: visibility">
    <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-lease-values-string"
                          groupName="leaseValuesString"
                          tooltipLabel="Lease Value(s)"
                          [disabled]="!canEdit()"
    >
      <albert-input controlName="leaseValuesString"
                    data-test="certificate-hull-cover-provision-lease-values-string"
                    groupName="leaseValuesString"
                    inputId="leaseValuesString"
                    label="Lease Value(s)"
                    [disabled]="true"

      />
    </albert-input-wrapper>
  </div>
  <div *albertIfCategory="'aircraftType'; config: visibility">
    @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE &&
    (form().controls.objectType.value === objectType.ENGINE || form().controls.objectType.value === objectType.EQUIPMENT)) {
      <div class="flex flex-col gap-6">
        <p class="font-semibold">Insured Aircraft to which the Equipment is attached</p>
        <div class="comparison-grid expanded-mode"
             data-test="certificate-hull-cover-provision-comparison-grid-insured-aircraft"
        >
          <div>
            <albert-select controlName="aircraftType"
                           data-test="certificate-hull-cover-provision-aircraft-type"
                           groupName="aircraftType"
                           inputId="aircraftType"
                           label="Aircraft Type"
                           [disabled]="!canEdit()"
                           [filter]="true"
                           [options]="aircraftTypeOptions()"
            />
          </div>
          <div class="override-cell">
            <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-type-for-cert-equipment"
                                  groupName="aircraftTypeForCertificates"
                                  tooltipLabel="Aircraft Type for Certificates"
                                  [disabled]="!canEdit()"
            >
              <albert-input controlName="aircraftTypeForCertificates"
                            data-test="certificate-hull-cover-provision-aircraft-type-for-cert-equipment"
                            groupName="aircraftTypeForCertificates"
                            inputId="aircraftTypeForCertificatesEquipment"
                            label="Aircraft Type for Certificates"
                            [disabled]="!canEdit()"
              />
            </albert-input-wrapper>
          </div>
          <div>
            <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-serial-number-equipment"
                                  groupName="aircraftSerialNumber"
                                  tooltipLabel="Aircraft Serial Number"
                                  [disabled]="!canEdit()"
            >
              <albert-select controlName="aircraftSerialNumber"
                             data-test="certificate-hull-cover-provision-aircraft-serial-number-equipment"
                             dataKey="uuid"
                             inputId="aircraftSerialNumberEquipment"
                             label="Aircraft Serial Number"
                             optionLabel="serialNumber"
                             optionValue="serialNumber"
                             [disabled]="!canEdit()"
                             [editable]="true"
                             [filter]="true"
                             [options]="aircraftSchedules() ?? []"
              />
            </albert-input-wrapper>
          </div>
          <div class="override-cell">
            <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-registration-equipment"
                                  groupName="aircraftRegistration"
                                  tooltipLabel="Aircraft Registration"
                                  [disabled]="!canEdit()"
            >
              <albert-select controlName="aircraftRegistration"
                             data-test="certificate-hull-cover-provision-aircraft-registration-equipment"
                             dataKey="uuid"
                             inputId="aircraftRegistrationEquipment"
                             label="Aircraft Registration"
                             optionLabel="registration"
                             optionValue="registration"
                             [disabled]="!canEdit()"
                             [editable]="true"
                             [filter]="true"
                             [options]="aircraftSchedules() ?? []"
              />
            </albert-input-wrapper>
          </div>
        </div>
      </div>
    }
  </div>
  @if (categoryService.activeCertificateCategory() === CertificateCategory.LEASE) {
    <div class="comparison-grid expanded-mode"
         data-test="certificate-hull-cover-provision-comparison-grid-4"
    >
      <div *albertIfCategory="'hullAllRiskDeductibleAmount'; config: visibility">
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-hull-all-risk-deductible-amount"
                              groupName="hullAllRiskDeductibleAmount"
                              tooltipLabel="Hull All Risk Deductible Amount"
                              [disabled]="!canEdit() || hullAllRiskDeductibleAmountLocked()"
        >
          <albert-limit class="flex-1"
                        currencyControlName="hullAllRiskDeductibleAmount.currency"
                        currencyGroupName="hullAllRiskDeductibleAmount.currency"
                        currencyInputId="hullAllRiskDeductibleAmountCurrency"
                        currencyLabel="Currency"
                        limitControlName="hullAllRiskDeductibleAmount.amount"
                        limitGroupName="hullAllRiskDeductibleAmount.amount"
                        limitInputId="hullAllRiskDeductibleAmountLimit"
                        limitLabel="Hull All Risk Deductible Amount"
                        [disabled]="!canEdit()"
          />
        </albert-input-wrapper>

      </div>

      <div *albertIfCategory="'remainingDeductibleAmount'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-remaining-deductible-amount"
                              groupName="remainingDeductibleAmount"
                              tooltipLabel="Remaining Deductible Amount"
                              [disabled]="!canEdit()"
        >
          <albert-limit class="flex-1"
                        currencyControlName="remainingDeductibleAmount.currency"
                        currencyGroupName="remainingDeductibleAmount.currency"
                        currencyInputId="remainingDeductibleAmountCurrency"
                        currencyLabel="Currency"
                        limitControlName="remainingDeductibleAmount.amount"
                        limitGroupName="remainingDeductibleAmount.amount"
                        limitInputId="remainingDeductibleAmountLimit"
                        limitLabel="Remaining Deductible Amount"
                        [disabled]="!canEdit()"
          />
        </albert-input-wrapper>
      </div>
    </div>
  }
  <div *albertIfCategory="'hullAllRiskDeductible'; config: visibility">
    <albert-checkbox controlName="hullAllRiskDeductible"
                     data-test="certificate-hull-cover-provision-hull-all-risk-deductible"
                     groupName="hullAllRiskDeductible"
                     inputId="hullAllRiskDeductible"
                     label="Hull All Risk Deductible"
                     [disabled]="!canEdit()"
    />
  </div>
  <div>
    <div *albertIfCategory="'hullAllRiskDeductibleAmount'; config: visibility">
      @if (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES ||
      categoryService.activeCertificateCategory() === CertificateCategory.CONTRACTUAL) {
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-hull-all-risk-deductible-amount"
                              groupName="hullAllRiskDeductibleAmount"
                              tooltipLabel="Hull All Risk Deductible Amount"
                              [disabled]="!canEdit() || (!form().controls.hullAllRiskDeductible.value)"
        >
          <albert-limit class="flex-1"
                        currencyControlName="hullAllRiskDeductibleAmount.currency"
                        currencyGroupName="hullAllRiskDeductibleAmount.currency"
                        currencyInputId="hullAllRiskDeductibleAmountCurrency"
                        currencyLabel="Currency"
                        limitControlName="hullAllRiskDeductibleAmount.amount"
                        limitGroupName="hullAllRiskDeductibleAmount.amount"
                        limitInputId="hullAllRiskDeductibleAmountLimit"
                        limitLabel="Hull All Risk Deductible Amount"
                        [disabled]="!canEdit() || (!form().controls.hullAllRiskDeductible.value)"
                        [required]="true"
          />
        </albert-input-wrapper>
      }
    </div>
  </div>

  @if (categoryService.activeCertificateCategory() !== CertificateCategory.LEASE) {
    <div class="comparison-grid expanded-mode"
         data-test="certificate-hull-cover-provision-comparison-grid-5"
    >
      <div *albertIfCategory="'fleetOfAircraft'; config: visibility">
        <albert-checkbox controlName="fleetOfAircraft"
                         data-test="certificate-hull-cover-provision-fleet-of-aircraft"
                         groupName="fleetOfAircraft"
                         inputId="fleetOfAircraft"
                         label="Fleet of Aircraft"
                         [disabled]="!canEdit()"
        />
      </div>
      <div *albertIfCategory="'addFleetListAsAttachment'; config: visibility"
           class="override-cell"
      >
        <albert-checkbox controlName="addFleetListAsAttachment"
                         data-test="certificate-hull-cover-provision-add-fleet-list-as-attachment"
                         groupName="addFleetListAsAttachment"
                         inputId="addFleetListAsAttachment"
                         label="Add Fleet List as Attachment"
                         [disabled]="!canEdit() || fleetListAsAttachmentLocked()"
        />
      </div>
    </div>
  }

  @if (((categoryService.activeCertificateCategory()
    === CertificateCategory.AUTHORITIES
    || categoryService.activeCertificateCategory()
    === CertificateCategory.CONTRACTUAL) && !!form().controls.addFleetListAsAttachment.value)) {
    <div class="comparison-grid expanded-mode"
         data-test="certificate-hull-cover-provision-comparison-grid-6"
    >
      <div *albertIfCategory="'columnConfiguration'; config: visibility"></div>
      <div *albertIfCategory="'columnConfiguration'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper *albertIfCategory="'addFleetListAsAttachment'; config: visibility"
                              data-test="wrapper-certificate-hull-cover-provision-column-configuration"
                              groupName="columnConfiguration"
                              tooltipLabel="Choose Fleet List Format"
                              [disabled]="!canEdit() || (!form().controls.addFleetListAsAttachment.value)"
        >
          <albert-select *albertIfCategory="'addFleetListAsAttachment'; config: visibility"
                         controlName="columnConfiguration"
                         data-test="certificate-hull-cover-provision-column-configuration"
                         inputId="columnConfiguration"
                         label="Choose Fleet List Format"
                         [disabled]="!canEdit() || (!form().controls.addFleetListAsAttachment.value)"
                         [options]="fleetListFormatOptions"
                         [required]="true"
          />
        </albert-input-wrapper>
      </div>
      <div *albertIfCategory="'filterByAircraftType'; config: visibility"></div>
      <div *albertIfCategory="'filterByAircraftType'; config: visibility"
           class="override-cell"
      >
        <albert-checkbox controlName="filterByAircraftType"
                         data-test="certificate-hull-cover-provision-filter-by-aircraft-type"
                         groupName="filterByAircraftType"
                         inputId="filterByAircraftType"
                         label="Filter by Aircraft Type"
                         [disabled]="!canEdit()"
        />
      </div>
      <div *albertIfCategory="'aircraftTypeFilter'; config: visibility"></div>
      <div *albertIfCategory="'aircraftTypeFilter'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper data-test="wrapper-certificate-hull-cover-provision-aircraft-type-filter"
                              groupName="aircraftTypeFilter"
                              tooltipLabel="Aircraft Type"
                              [disabled]="!canEdit() || !form().controls.filterByAircraftType.value"
        >
          <albert-multiselect controlName="aircraftTypeFilter"
                              dataTest="certificate-hull-cover-provision-aircraft-type-filter"
                              inputId="aircraftTypeFilter"
                              label="Aircraft Type"
                              [disabled]="!canEdit() || !form().controls.filterByAircraftType.value"
                              [filter]="true"
                              [maxSelectedLabels]="3"
                              [options]="aircraftTypeFilterOptions()"
          />
        </albert-input-wrapper>
      </div>
      <div *albertIfCategory="'includePlannedAircraft'; config: visibility"></div>
      <div *albertIfCategory="'includePlannedAircraft'; config: visibility"
           class="override-cell"
      >
        <albert-checkbox controlName="includePlannedAircraft"
                         data-test="certificate-hull-cover-provision-include-planned-aircraft"
                         groupName="includePlannedAircraft"
                         inputId="includePlannedAircraft"
                         label="Include Planned Aircraft"
                         [disabled]="!canEdit()"
        />
      </div>
      @if (categoryService.activeCertificateCategory() !== CertificateCategory.LSG) {
        <div></div>
        <div *albertIfCategory="'previewFleetList' ; config: visibility"
             class="override-cell"
        >
          <button data-test="certificate-hull-cover-provision-preview-fleet-list"
                  label="Preview Fleet List"
                  pButton
                  severity="secondary"
                  type="button"
                  [disabled]="!form().controls.addFleetListAsAttachment.value"
                  (click)="onPreviewFleetList()"
          >
            Preview Fleet List
          </button>
        </div>
      }
    </div>
  }

  <div class="comparison-grid expanded-mode"
       data-test="certificate-hull-cover-provision-comparison-grid-7"
  >
    <div *albertIfCategory="'hullInsurance'; config: visibility">
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.hullInsurance"
      />
    </div>
    <div *albertIfCategory="'sparesAllRiskInsurance'; config: visibility"
         class="override-cell"
    >
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.sparesAllRiskInsurance"
      />
    </div>
  </div>

  <div class="comparison-grid expanded-mode"
       data-test="certificate-hull-cover-provision-comparison-grid-8"
  >
    <div *albertIfCategory="'hullWarInsurance'; config: visibility">
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.hullWarInsurance"
      />
    </div>
    <div class="override-cell flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'includeEngineTestRunOnCertificate'; config: visibility"
                       controlName="includeEngineTestRunOnCertificate"
                       data-test="certificate-hull-cover-provision-include-engine-test-run-on-certificate"
                       groupName="includeEngineTestRunOnCertificate"
                       inputId="includeEngineTestRunOnCertificate"
                       label="Include Engine Test Run on Certificate"
                       [disabled]="!canEdit()"
      />

      <albert-checkbox *albertIfCategory="'includeSparesDeductibleOnCertificate'; config: visibility"
                       controlName="includeSparesDeductibleOnCertificate"
                       data-test="certificate-hull-cover-provision-include-spares-deductible-on-certificate"
                       groupName="includeSparesDeductibleOnCertificate"
                       inputId="includeSparesDeductibleOnCertificate"
                       label="Include Spares Deductible on Certificate"
                       [disabled]="!canEdit()"
      />
    </div>
  </div>

  <div class="comparison-grid expanded-mode"
       data-test="certificate-hull-cover-provision-comparison-grid-9"
  >
    <div *albertIfCategory="'waiverOfSubrogation'; config: visibility">
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.waiverOfSubrogation"
      />
    </div>
    <div *albertIfCategory="'noLiabilityForPremiums'; config: visibility"
         class="override-cell"
    >
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.noLiabilityForPremiums"
      />
    </div>

    <div class="flex flex-col gap-2">
      <albert-checkbox *albertIfCategory="'noticeOfCancellationInclWar'; config: visibility"
                       controlName="noticeOfCancellationInclWar"
                       data-test="certificate-hull-cover-provision-notice-of-cancellation-incl-war"
                       groupName="noticeOfCancellationInclWar"
                       inputId="certificate-hull-cover-provision-noticeOfCancellationInclWar"
                       label="Notice of Cancellation (incl. War)"
                       [disabled]="!canEdit()"
      />

      <albert-freetext-section *albertIfCategory="'noticeOfCancellationNoWar'; config: visibility"
                               dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.noticeOfCancellationNoWar"
      />
    </div>
    <div *albertIfCategory="'breachOfWarranty'; config: visibility"
         class="override-cell"
    >
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.breachOfWarranty"
      />
    </div>
    <div *albertIfCategory="'additionalInsured'; config: visibility"></div>
    <div *albertIfCategory="'additionalInsured'; config: visibility"
         class="override-cell"
    >
      <albert-freetext-section dataTestPrefix="certificate-hull-cover-provision"
                               [form]="form()"
                               [section]="freetextSectionsByKey.additionalInsured"
      />
    </div>
  </div>

</div>

<ng-template #fleetListPreview>
  <div class="fleet-list-preview">
    <p-table data-test="certificate-hull-cover-provision-fleet-list-preview"
             scrollHeight="693px"
             scrollable="true"
             [value]="fleetListPreviewRows()"
    >
      <ng-template #header>
        <tr>
          <th id="preview-status">Status</th>
          <th id="preview-aircraft-type">Aircraft Type</th>
          <th id="preview-registration">Registration</th>
          <th id="preview-msn">MSN</th>
          <th id="preview-mtow">MTOW</th>
          <th class="align-right"
              id="preview-avn52-limit"
          >AVN52 Limit
          </th>
        </tr>
      </ng-template>
      <ng-template #body
                   let-schedule
      >
        <tr>
          <td>
            <p-tag rounded="true"
                   [severity]="getStatusSeverity(schedule.objectStatus)"
                   [value]=""
            />
          </td>
          <td>{{ schedule.aircraftType }}</td>
          <td>{{ schedule.registration }}</td>
          <td>{{ schedule.serialNumber }}</td>
          <td>{{ schedule.mtow | formatCurrencyAmount: '' }}</td>
          <td class="align-right">{{ schedule.tpllWarExcessLimit | formatCurrencyAmount: schedule.tpllWarExcessLimitCurrency }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="6">No aircraft match the current fleet list settings.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-template>
